<div class="container layout-vbox" style="overflow: auto">
    <h4>
        Worksheets
        <fluent-button appearance="stealth" (click)="listWorksheets()">
            <i class="fas fa-sync"></i>
        </fluent-button>
    </h4>

    <div style="width: 100%; flex: 1; overflow: hidden">
        <wj-flex-grid #grid [itemsSource]="sheets" style="height: 100%" [isReadOnly]="true" headersVisibility="Column" selectionMode="Row"
                      (dblclick)="showSheet()"
                      (contextmenu)="showContextMenu($event)">
            >
            <wj-flex-grid-column [header]="'Sheet Name'" [binding]="'name'" width="*"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Position'" [binding]="'position'" [width]="40" [visible]="false"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Visibility'" [binding]="'visibility'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Used'" [binding]="'usedRange'" [visible]="false"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>

    <div class="toolbar">
        <fluent-button appearance="accent" [attr.disabled]="disabled()" (click)="showSheet()">Show</fluent-button>
        <fluent-button appearance="accent">Unlock</fluent-button>
    </div>
</div>

<wj-menu #itemMenu (itemClicked)="menuItemClicked(itemMenu)" style="display: none"
         selectedValuePath="cmd" [itemsSource]="ctxMenu"
         subItemsPath="items" displayMemberPath="header">
</wj-menu>
